import { getPrivacyPolicyContent } from "api/rental-agreement/rental-agreement";
import { useEffect, useState } from "react";
import { formatPhoneLabel } from "utils/PhoneFormat";
import { useData } from "data/data-provider";

function TermsandConditions() {
  const [content, setContent] = useState([]); // Ensure content is always an array
  const [loading, setLoading] = useState(false);
  const { ourCompany } = useData();

  useEffect(() => {
    const getContent = async () => {
      setLoading(true);
      try {
        const response = await getPrivacyPolicyContent();

        // Ensure data is an array or default to an empty array
        setContent(response.data.terms_condition);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching content", error);
      }
    };

    getContent();
  }, []);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="mt-6 rounded-lg  bg-white p-4 min-h-[60vh]">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-text-color text-center">
            Terms & Conditions
          </h1>
          <p className="max-96 text-sm text-[#86909C]"></p>
        </div>
        {loading ? (
          <div className="flex justify-center items-center col-span-full min-h-[100vh]">
            <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-700"></div>
          </div>
        ) : (
          <div className="col-span-12 container">
            <div className="flex flex-col gap-y-4">
              {content?.length > 0 ? (
                content?.map((item: any, i: any) => (
                  <div className="rounded-lg border border-muted" key={i}>
                    <div className="header rounded-lg bg-[#f7f7f7] px-5 py-3">
                      <h4 className="text-lg">
                        {i + 1}. {item?.title}
                      </h4>
                    </div>
                    <div className="header border-t border-muted p-5 w-full">
                      <div className="grid grid-cols-1 gap-3 rounded-lg w-full">
                        <div
                          className="prose prose-sm ql-content text-text-color break-words"
                          style={{ maxWidth: "100%" }}
                          dangerouslySetInnerHTML={{
                            __html: item?.content
                              ?.replace(
                                /\{\{phone\}\}/g,
                                formatPhoneLabel(ourCompany?.company?.phone_no),
                              )
                              ?.replace(
                                /\{\{email\}\}/g,
                                ourCompany?.company?.email,
                              )
                              ?.replace(
                                /\{\{address\}\}/g,
                                ourCompany?.company?.address,
                              )
                              ?.replace(
                                /\{\{deposit amount\}\}/g,
                                "$" + ourCompany?.default_deposit_amount,
                              ),
                          }}
                        />
                      </div>
                    </div>
                    {item?.content_picture &&
                      item?.content_picture !== "null" && (
                        <div className="header border-t border-muted p-5">
                          <div className="grid grid-cols-1 gap-3 rounded-lg">
                            <img
                              alt="terms and conditions image"
                              src={`https://fleet-management-images-upload-be.s3.amazonaws.com/${item?.content_picture}`}
                              height={660}
                              width={600}
                              className="w-full rounded-lg"
                            />
                          </div>
                        </div>
                      )}
                  </div>
                ))
              ) : (
                <p>No content available.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TermsandConditions;
